import {MspMemberRegionActions, RegionMspMemberActionTypes} from '../actions/region-msp-member-authority.actions';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';

export interface State {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialState: State = {
  Loaded: false,
  Loading: false,
  entities: null
};

export function reducer(state = initialState, action: MspMemberRegionActions): State {
  switch (action.type) {
    case RegionMspMemberActionTypes.GetMspMemberRegions:
      return {...state, Loaded: false, Loading: true};

    case RegionMspMemberActionTypes.GetMspMemberRegionSuccess:
      return {...state, Loaded: true, Loading: false, entities: action.payload};

    case RegionMspMemberActionTypes.GetMspMemberRegionFail: {
      return {...state, Loaded: true, Loading: false};
    }

    default:
      return state;
  }
}

export const getMspMemberRegionState = (state: State) => state;
